import { useQuery } from '@tanstack/react-query';
import { jsonGet } from '../api/jsonRequest';
import { refetchIntervalWhenTabVisible } from './queryConfig';

export function createPollQueryOptions({ pauseRefetch = false, refetchInterval } = {}) {
    const interval = refetchInterval ?? refetchIntervalWhenTabVisible;
    return {
        keepPreviousData: true,
        staleTime: 0,
        refetchInterval: pauseRefetch ? false : interval,
        refetchOnWindowFocus: !pauseRefetch,
        refetchOnReconnect: !pauseRefetch,
    };
}

/** TanStack read hook for server-backed lists. Returns query result directly. */
export function usePollQuery({
    queryKey,
    url,
    enabled = true,
    pauseRefetch = false,
    refetchInterval,
} = {}) {
    return useQuery({
        queryKey,
        queryFn: () => jsonGet(url),
        enabled: Boolean(enabled && url),
        ...createPollQueryOptions({ pauseRefetch, refetchInterval }),
    });
}
